module.exports = __webpack_public_path__ + "img/ru.517e32a1.svg";